module.exports = __webpack_public_path__ + "img/g12.edaaad97.jpg";